var _style, _path, _path2, _path3, _path4, _path5, _defs, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComeback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#CCCFD8;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_00000081615101903318829300000002792564616036015790_);}\r\n\t.st4{fill:url(#SVGID_00000088130591654486383320000000205335068800020616_);}\r\n\t.st5{fill:url(#SVGID_00000103267043648771389930000017958998952907767197_);}\r\n\t.st6{fill:url(#SVGID_00000012468826650568459070000001779903687952420740_);}\r\n\t.st7{fill:url(#SVGID_00000108288586929017851020000009608094702375926675_);}\r\n\t.st8{fill:url(#SVGID_00000086691630788370820240000000679576632055187131_);}\r\n\t.st9{fill:url(#SVGID_00000168108823274130032900000010066941113446985903_);}\r\n\t.st10{fill:url(#SVGID_00000166664874001260112250000005267883672972064928_);}\r\n\t.st11{fill:url(#SVGID_00000051365028446308667140000008085030177312840888_);}\r\n\t.st12{fill:url(#SVGID_00000011022936356847018640000008108137141771186085_);}\r\n\t.st13{fill:url(#SVGID_00000156558186449318128830000000645697532085062536_);}\r\n\t.st14{fill:#341D0D;}\r\n\t.st15{fill:#875B47;}\r\n\t.st16{opacity:0.9;fill:url(#SVGID_00000085969674206200307230000001722458542486194613_);enable-background:new    ;}\r\n\t.st17{opacity:0.9;fill:url(#SVGID_00000101819721571719332410000007608480023513306778_);enable-background:new    ;}\r\n\t.st18{fill:url(#SVGID_00000145756360951882139110000016272286737124548537_);}\r\n\t.st19{fill:url(#SVGID_00000007391281007155348990000001962038855990003590_);}\r\n\t.st20{fill:url(#SVGID_00000155849781527341580230000010397495331243146654_);}\r\n\t.st21{fill:url(#SVGID_00000114051924116242907070000004672337991282276798_);}\r\n\t.st22{fill:url(#SVGID_00000012473723407203802950000017934490845480422817_);}\r\n\t.st23{fill:url(#SVGID_00000087411113072888487470000010587090917225845924_);}\r\n\t.st24{fill:#DC53E1;}\r\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:#8754A1;}\r\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#D4A0F2;}\r\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#40225D;}\r\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "web"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -2677.9529,
    cy: 162.8216,
    r: 32.2492,
    gradientTransform: "matrix(-1 0 0 -1 -2635.1001 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.8,36.8c0,0-2.1-6.5-12.6-12.5c-10.5-6-18-15.5-21-18.1S32.7,1.5,29,2.7c-4.9,1.5-26.1,52.2-1,69.8 S69.8,36.8,69.8,36.8L69.8,36.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.1,43c0,0-6.6,0.5-10-7.2c6.7,0.5,15.4,0,15.4,0s-22,2.6-31.1-32.8c-0.6,0.2-3.2,2.6-6.2,15.4 s-8,39.8,5.5,48.1C43.2,74.9,56.1,43,56.1,43L56.1,43z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.7,46c0,0-7-3.8-10.4-11.4c6.7,0.5,11.3,1.1,11.3,1.1S36.1,32,29.5,5.8c-0.6,0.2-2,2.3-5,15.1 s-6.1,41.6,8.7,46.8C48.1,72.9,53.7,46,53.7,46L53.7,46z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000179643257071263512180000017365792172798587297_",
    cx: -5001.0625,
    cy: 2658.9575,
    r: 27.39,
    gradientTransform: "matrix(-0.3418 -0.7233 0.4159 -0.1965 -2773.1917 -3036.7227)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FFD342"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179643257071263512180000017365792172798587297_)"
    },
    d: "M28.1,27.1c-6.3,3-7.2,14.2-2.1,25.1 c5.1,10.9,14.4,17.3,20.7,14.3c6.3-3,7.2-14.2,2.1-25.1S34.4,24.1,28.1,27.1L28.1,27.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000157269847432543444570000007496038263068042129_",
    cx: -1537.8774,
    cy: 152.3405,
    r: 32.2494,
    gradientTransform: "matrix(0.9928 0.1194 0.1194 -0.9928 1680.9969 405.2032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157269847432543444570000007496038263068042129_)"
    },
    d: "M145.9,64.7c0,0,2.8-6.2,14-10.9 c11.2-4.7,19.7-13.2,23-15.5s4-4.3,7.6-2.7c4.7,2.1,19.7,55-7.4,69.4S145.9,64.7,145.9,64.7L145.9,64.7z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.7,72.5c0,0,6.5,1.3,10.7-5.9c-6.7-0.3-15.3-1.8-15.3-1.8S175.7,70,189,35.9c0.6,0.3,2.9,2.9,4.3,16 c1.4,13.1,3.1,40.4-11.2,47.1C167.7,105.7,158.7,72.5,158.7,72.5L158.7,72.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.7,75.7c0,0,7.4-2.9,11.6-10.1c-6.7-0.3-11.3-0.3-11.3-0.3s18.9-1.4,28.5-26.7 c0.6,0.3,1.8,2.5,3.2,15.6s1.1,42-14.2,45.4C163.1,103.1,160.7,75.7,160.7,75.7L160.7,75.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000012461733050197606090000012427520719067141777_",
    cx: -4406.4009,
    cy: 405.5141,
    r: 27.39,
    gradientTransform: "matrix(0.4257 -0.6773 -0.3895 -0.2448 2204.9805 -2793.8271)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FFD342"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012461733050197606090000012427520719067141777_)"
    },
    d: "M188.4,60c5.9,3.7,5.5,15-0.9,25.2 c-6.4,10.2-16.4,15.5-22.3,11.8c-5.9-3.7-5.5-15,0.9-25.2C172.5,61.6,182.5,56.3,188.4,60z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080895113162508037190000018354524128293018812_",
    cx: 94.03,
    cy: 101.124,
    r: 80.7324,
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080895113162508037190000018354524128293018812_)"
    },
    d: "M178.6,130.3c0.2-0.3,0.5-0.5,0.8-0.7 c2.3-1.2,6.8,0.7,6.8,0.7c-0.9-4-4.3-7.8-9-11c0-3.2-0.2-6.4-0.8-9.5c-1-5.8-3.1-12.4-6.3-21.3c-1.6-4.6-3.6-8.9-5.9-13.1 c-1.1-1.9-2.3-3.7-3.6-5.5c-2.4-3.3-5-6.4-7.9-9.2c-2.2-2.3-4.6-4.4-7.1-6.4c-0.8-0.7-1.7-1.4-2.6-2c-1.8-1.4-3.7-2.7-5.6-3.9 c-10.1-6.5-21.1-11-31.4-13.2c-3.7-0.6-7.2-1.1-10.5-1.4c-9.5-0.8-17.7-0.1-24.7,1.5c-4,1-7.7,2.2-11,3.8 c-1.3,0.6-2.5,1.2-3.7,1.8c-3.3,1.8-6.3,3.9-9,6.1c-1.3,1.1-2.6,2.3-3.9,3.4c-2.7,2.6-5.1,5.3-7.3,7.9c-3.3,3.9-6.1,8.3-9.3,12.3 c-2.4,3-5.2,5.6-7.2,8.9c-1.3,2.3-2.8,5.2-4.1,8.2c-3.6,0.4-6.4,2.2-10.8,6.1c0,0,2.9,0.1,5.1,2.1c-1.1,0.2-1.9,0.7-2.7,1.3 c-2.5,1.9-3.5,5-4.9,6.6c0,0,7-1.8,7.9,0.7c-0.4,0.1-0.8,0.2-1.2,0.4c-3.3,1.4-5.2,4.6-5.9,6.5c0.8,0.5,1.9,1.1,3.1,2 c2.6,1.9,5.7,4.6,8.6,8.5c0.1,0.1,0.1,0.2,0.1,0.4c3.4,7.9,10.9,15.5,19.6,18.4c1.2,0.8,2.2,1.5,3.2,2.3 c5.1,4.3,6.8,9.3,14.6,13.1c9.7,4.7,21.5,8.7,35.9,10.8c12.8,1.8,26,2.2,38.8,0.4c2.9-0.4,5.6-0.9,8.1-1.5 c6-0.9,11.3-2.5,15.8-4.6c3.8-1.7,7-3.8,9.9-6.1c0.1-0.1,0.3-0.2,0.4-0.4l0,0c2.5-1.6,4.8-3.6,7.4-4.8c5.5-2.6,9.9-2.7,10.7-3.4 c0.1,0,0.1-0.1,0.1-0.1c0.3-0.9-3.4-5.9-4.4-7.3c0.6,0.2,1.8,0,3.2-0.2c1.8-0.2,4.1-0.4,6.3,0.3 C183.8,132.8,178.5,130.4,178.6,130.3L178.6,130.3z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135666367089541552590000011319269720779826878_",
    d: "M97.1,162.8c6.4,2.4,27.6,5.4,39.3,2.6 c0,0,28.1-30,17.5-41.2S115.3,87,86.9,83.4c-28.4-3.6-49.7-3.7-60.7,8.1c0,0-13.3,16.1-14.4,20.9c2.5,14.9,11.3,24.2,22.9,28.4 C34.7,140.8,97.1,162.8,97.1,162.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153702272161439093000000004989523332703135111_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135666367089541552590000011319269720779826878_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000120556191157305965150000001152445325561317259_",
    cx: 77.5557,
    cy: 72.9195,
    r: 42.1792,
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#220E29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF2EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#FBEDE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#F1E1D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#E1CCC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#CAAFA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFA194"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120556191157305965150000001152445325561317259_)"
    },
    d: "M113.4,158.7c-1.1,0.7-2.3,1.3-3.6,1.9 c-2.9,1.3-6.4,2.2-10.5,2.6c-4.1,0.4-8.9,0.3-14.4-0.4c-3.1-0.4-6.5-1-10.1-1.9c-3.6-0.9-7.6-2-11.7-3.4 c-5.7-2.1-10.5-4.2-14.6-6.4c-4.9-2.6-8.8-5.2-11.8-8c-4.5-4.2-7.4-9.6-7.8-15.8c-0.1-2.6,0.1-5.2,0.7-7.9 c1.1-4.9,2.8-10.8,6-15.8c2-2.7,4.3-4.4,6.6-6c2.3-1.5,5-2.1,7.6-2.6c4.5-0.9,9.4-0.2,14.4,1.9c3.8,1.6,7.6,3.9,11.5,6.9 c0,0,2.1,0.3,4.6,0.7c3.6,0.5,8.1,1.1,8.8,0.9c4.1-0.1,9.3-0.2,14.4,0.8c2.8,0.5,5.6,1.4,8.2,2.6c5.9,2.9,12.1,7.8,13.9,17.1 c1.2,6.1,1,13.5-0.9,19.5C122.9,151.3,119.1,155,113.4,158.7L113.4,158.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000072969178963970950760000016879420520574186637_",
    cx: -3240.0068,
    cy: 39.2676,
    r: 18.27,
    gradientTransform: "matrix(-0.9862 -0.1654 0.1654 -0.9862 -3126.9661 -359.2796)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#A63D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#631E2C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072969178963970950760000016879420520574186637_)"
    },
    d: "M66.6,114.6 c-3.7,15.1-1.2,20.1,8.5,22.5c12,2.5,10.7-8.1,13.9-17.8c0,0-7.7-0.8-9-9.4c-1.4-8.6,0,0,0,0S74.5,117.6,66.6,114.6L66.6,114.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080194745467543733610000012576180097538581121_",
    gradientUnits: "userSpaceOnUse",
    x1: -3298.5996,
    y1: 103.678,
    x2: -3298.5996,
    y2: 96.2879,
    gradientTransform: "matrix(-0.9806 -0.1959 0.1959 -0.9806 -3172.7495 -444.2338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080194745467543733610000012576180097538581121_)"
    },
    d: "M76.8,107c-1.6-5.9-6.1-4.2-6.4-7.7 c-0.3-4.1,5.7-3.9,8.8,0.1c1.2,1.5,3,1.7,5.1,0.9c3.8-1.8,8.8-0.3,9.4,2.6c0.4,1.9-1,5.2-3.8,4.3c-2.9-0.9-5.9-0.4-7.5,1.8 C80.5,111.3,77.4,109.7,76.8,107z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114061774232270503430000002163658209849417135_",
    gradientUnits: "userSpaceOnUse",
    x1: -3307.3706,
    y1: 103.6879,
    x2: -3307.3706,
    y2: 96.2879,
    gradientTransform: "matrix(-0.9806 -0.1959 0.1959 -0.9806 -3172.7495 -444.2338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114061774232270503430000002163658209849417135_)"
    },
    d: "M81.6,107.1 c-1.8,15.2,14.5,11.7,16.1,9.6c0.8-0.6,0.5,2.1-3.5,3.2c-2.9,0.8-5.7,0.8-8.8-0.2c-4.2-1.4-7.7-6.2-5.9-11.8 C79.5,107.9,81.6,107.1,81.6,107.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145777408514454464670000017729420152711200938_",
    gradientUnits: "userSpaceOnUse",
    x1: -3289.6763,
    y1: 104.3779,
    x2: -3289.6763,
    y2: 96.998,
    gradientTransform: "matrix(-0.9806 -0.1959 0.1959 -0.9806 -3172.7495 -444.2338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145777408514454464670000017729420152711200938_)"
    },
    d: "M63.1,108.6c3.6,9.4,14.6,4.9,16.1-2.9 l2.1,0.8c-0.7,3.7-4.3,11-13.4,9.1c-3.6-1.1-5.2-3.8-5.8-5.7C61.8,108.9,62.3,107.1,63.1,108.6L63.1,108.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000183222010365698434020000016906388584543705255_",
    cx: -3327.0684,
    cy: 114.5379,
    r: 8.35,
    gradientTransform: "matrix(-0.9806 -0.1959 0.1959 -0.9806 -3172.7495 -444.2338)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183222010365698434020000016906388584543705255_)"
    },
    d: "M105.8,94.1c-1,5.3,1.2,10.2,4.7,10.8 c3.6,0.7,7.2-3.2,8.2-8.5c1-5.3-1.1-10.2-4.7-10.8C110.4,85,106.8,88.8,105.8,94.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000172430466105443396240000015316170933234939287_",
    cx: -1486.5,
    cy: -60.92,
    r: 7.7,
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172430466105443396240000015316170933234939287_)"
    },
    d: "M54.4,82.5c-0.9,4.9,1.1,9.4,4.3,10 c3.3,0.6,6.7-2.9,7.6-7.8c0.9-4.9-1.1-9.4-4.3-10S55.3,77.5,54.4,82.5L54.4,82.5z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.3,91.4c-0.2,1.1,0.3,2.1,1,2.2c0.8,0.1,1.6-0.6,1.8-1.7c0.2-1.1-0.3-2.1-1-2.2 C114.3,89.6,113.5,90.4,113.3,91.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,80c-0.2,1.2,0.3,2.3,1.2,2.4c0.8,0.2,1.7-0.7,1.9-1.9c0.2-1.2-0.3-2.3-1.1-2.4 C62.2,78,61.4,78.8,61.2,80L61.2,80z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M78,106.5c0-0.2,0.3-6.8-5.5-6.3C72,100.6,76.7,101.2,78,106.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.5,106.3c-1.1-1.1-6-3.9-8.3,2C85.3,106,87.1,105.1,91.5,106.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.8,97.6c-0.7-0.9-2.2-1.7-3.2-1c-0.6,0.7,0.8,1.1,1.3,1.2S77.1,98.1,76.8,97.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.5,100.1c1-0.5,2.8-0.4,3.3,0.7c0.2,0.9-1.3,0.6-1.7,0.4C90.6,101.1,88.9,100.4,89.5,100.1L89.5,100.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000090255844539343733180000014066369356952676754_",
    cx: -3027.1809,
    cy: 770.5369,
    r: 1.37,
    gradientTransform: "matrix(-1.4925 -0.3796 0.3461 -1.243 -4668.0293 -74.5149)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000090255844539343733180000014066369356952676754_)",
      enableBackground: "new"
    },
    d: " M108.7,114.4c-0.2,0.7,0.8,1.5,2.1,1.9c1.4,0.3,2.6,0.1,2.8-0.6c0.2-0.7-0.8-1.5-2.1-1.9C110.2,113.4,108.9,113.7,108.7,114.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000132807040800287969740000001326994464750142390_",
    cx: -2965.4553,
    cy: 765.3535,
    r: 1.29,
    gradientTransform: "matrix(-1.4689 -0.3499 0.3179 -1.2504 -4552.3491 18.0636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000132807040800287969740000001326994464750142390_)",
      enableBackground: "new"
    },
    d: " M50.5,99.8c-0.2,0.6,0.7,1.4,2,1.7c1.3,0.3,2.4,0,2.6-0.6c0.2-0.7-0.7-1.4-2-1.7C51.8,98.9,50.7,99.1,50.5,99.8L50.5,99.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020398112666000674880000003580136297281442207_",
    gradientUnits: "userSpaceOnUse",
    x1: -2785.8958,
    y1: 88.1693,
    x2: -2743.2432,
    y2: 88.1693,
    gradientTransform: "matrix(-1 0 0 -1 -2635.1001 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020398112666000674880000003580136297281442207_)"
    },
    d: "M150.2,117.3c-0.1,0-0.3,0-0.4-0.1 c-13.6-10.7-40.6-2.9-40.9-2.8c-0.3,0.1-0.7-0.1-0.8-0.4c-0.1-0.3,0.1-0.7,0.4-0.8c0.1,0,7-2,15.6-2.7c8-0.6,19-0.1,26.4,5.7 c0.3,0.2,0.3,0.6,0.1,0.9C150.6,117.2,150.4,117.3,150.2,117.3L150.2,117.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152960914976433414330000010035631680265624505_",
    gradientUnits: "userSpaceOnUse",
    x1: -2923.6592,
    y1: 95.942,
    x2: -2878.9138,
    y2: 95.942,
    gradientTransform: "matrix(-0.9967 -8.141663e-02 8.141663e-02 -0.9967 -2769.3762 -16.1649)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152960914976433414330000010035631680265624505_)"
    },
    d: "M151.4,131.3c-0.2,0-0.3-0.1-0.4-0.2 c-13.6-13.7-41.9-11.7-42.2-11.7c-0.3,0-0.6-0.2-0.7-0.6c0-0.3,0.2-0.6,0.6-0.7c0.1,0,7.3-0.5,16.2,0.7c8.2,1.1,19.6,4,26.9,11.3 c0.2,0.2,0.2,0.6,0,0.9C151.7,131.3,151.6,131.3,151.4,131.3L151.4,131.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047740993156206286130000014760060844766757016_",
    gradientUnits: "userSpaceOnUse",
    x1: -3176.0205,
    y1: 396.7819,
    x2: -3132.7104,
    y2: 396.7819,
    gradientTransform: "matrix(-0.9269 -0.208 0.2606 -1.1611 -2903.9282 -60.5965)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047740993156206286130000014760060844766757016_)"
    },
    d: "M142.9,149c-0.2,0-0.5-0.1-0.6-0.4 c-8.3-22.5-34.4-25.5-34.7-25.5c-0.3,0-0.6-0.3-0.6-0.7c0-0.3,0.3-0.6,0.7-0.6c0.3,0,27.1,3.1,35.7,26.3c0.1,0.3-0.1,0.7-0.4,0.8 C143,149,142.9,149,142.9,149L142.9,149z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153673079941676036880000014055066610022947716_",
    gradientUnits: "userSpaceOnUse",
    x1: -1755.8837,
    y1: 521.9717,
    x2: -1722.4523,
    y2: 521.9717,
    gradientTransform: "matrix(0.8791 0.4767 0.4767 -0.8791 1317.0347 1377.1659)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153673079941676036880000014055066610022947716_)"
    },
    d: "M50.2,99.3c-0.2,0-0.4-0.1-0.5-0.2 c-0.1-0.2-13.4-16.7-27.5-15.6c-0.3,0-0.6-0.2-0.7-0.6s0.2-0.6,0.6-0.7c6.2-0.5,13.1,2.1,20,7.6c5.2,4.1,8.5,8.3,8.6,8.4 c0.2,0.3,0.2,0.7-0.1,0.9C50.5,99.2,50.4,99.3,50.2,99.3L50.2,99.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026127312554813115300000005880216857959068849_",
    gradientUnits: "userSpaceOnUse",
    x1: -1860.9543,
    y1: 444.0391,
    x2: -1826.4712,
    y2: 444.0391,
    gradientTransform: "matrix(0.915 0.4035 0.4035 -0.915 1539.0779 1249.3945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026127312554813115300000005880216857959068849_)"
    },
    d: "M47.8,103.6c-0.2,0-0.4-0.1-0.5-0.3 c-1.9-2.7-20.7-12.2-32.6-6.5c-0.3,0.2-0.7,0-0.8-0.3s0-0.7,0.3-0.8c12.7-6.1,32.1,4,34.2,6.9c0.2,0.3,0.1,0.7-0.1,0.9 C48.1,103.6,47.9,103.6,47.8,103.6L47.8,103.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058565971424413835280000010818184422960306081_",
    gradientUnits: "userSpaceOnUse",
    x1: -2015.9464,
    y1: 562.8712,
    x2: -1984.0565,
    y2: 562.8712,
    gradientTransform: "matrix(0.914 0.2591 0.3246 -1.1449 1678.3646 1274.5869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#663D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#432A1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058565971424413835280000010818184422960306081_)"
    },
    d: "M13.6,116.1c-0.1,0-0.2,0-0.3-0.1 c-0.3-0.2-0.4-0.6-0.2-0.8c3.8-6,10.8-9.4,20.2-10.1c7.1-0.5,13,0.8,13.2,0.8c0.3,0.1,0.5,0.4,0.5,0.7s-0.4,0.5-0.7,0.5 c-0.2-0.1-23.5-5-32.2,8.7C14.1,116,13.9,116.1,13.6,116.1z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M165.9,150.5c0,0-76,23.2-127.8-5.3c0,0-2.6,6.7,0.3,10c5.1,5.8,56.4,28.2,128.5,2.9 C166.9,158.2,170.6,153.8,165.9,150.5L165.9,150.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st25",
    d: "M92.2,183.4c-1.2,9.9-10.2,16.9-20.1,15.7c-9.9-1.2-16.9-10.2-15.7-20.1s10.2-16.9,20.1-15.7 S93.5,173.5,92.2,183.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st26",
    d: "M87.9,182.9c-0.9,7.6-7.9,13-15.5,12.1c-7.6-0.9-13-7.9-12-15.5c1-7.6,7.9-13,15.5-12.1 S88.9,175.3,87.9,182.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st27",
    d: "M87.9,183.6c-0.9,7.2-7.6,12.3-15,11.4c-7.4-0.9-12.7-7.5-11.8-14.8s7.6-12.3,15-11.4 C83.5,169.8,88.8,176.4,87.9,183.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M66,185.1l-0.9,3.1l7.1,0.9c-1.4-0.2-0.7-3.3-2.9-3.5L66,185.1L66,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M79,183.2c2-0.5,3.5-2.2,3.6-4.2c0.2-2.6-1.8-4.9-4.5-5.2l-8.5-1.1l-0.9,3.1l7,0.9l0.1-0.9l2.3,2.9 l-2.9,2.2l0.1-1.1l-7.6-0.9l-0.9,3.1l5.3,0.7c1.2,0.2,2.2,1,2.7,2.1l1.2,3.3c0.3,0.9,1.2,1.6,2.2,1.7l3.5,0.4L79,183.2 L79,183.2z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComeback);
export default __webpack_public_path__ + "static/media/comeback.9a5b2c3120fca65cf1df2679c31e75dc.svg";
export { ForwardRef as ReactComponent };